import toastr from 'toastr';
import i18n from '@/i18n.bootstrap';
import userDataApi from './../../api/userData.js';

export default {
    loadUserData: ({ commit }, routerCallback) => {
        userDataApi.loadUserData().then(
            response => {
                if (!response) {
                    commit('setUserData', { loggedIn: false, data: {} });
                    console.log(
                        'loadUserData error: empty response object of request: /epr/user/me',
                        { ...response }
                    );
                } else if (response.data instanceof Object) {
                    commit('setUserData', {
                        loggedIn: true,
                        data: { ...response.data }
                    });
                    commit('setLanguage', response.data.language);

                    if (routerCallback) {
                        routerCallback(true);
                    }
                } else {
                    commit('setUserData', { loggedIn: false, data: {} });

                    if (routerCallback) {
                        routerCallback(false);
                    }
                }
            },
            error => {
                commit('setUserData', { loggedIn: false, data: {} });
                console.log('loadUserData error', { ...error });

                if (routerCallback) {
                    routerCallback(false);
                }
            }
        );
    },

    setLanguage: ({ commit }, lang) => {
        commit('setLanguage', lang);
    },

    updateMe: ({ commit }, user) => {
        return userDataApi.updateMe(user)
            .then((response) => {
                commit('updateUserData', response.data);
                toastr.success(i18n.t('profile.messages.action.success'));
            }).catch((error) => {
                toastr.error(i18n.t('profile.messages.action.error'));
                console.log('loadUserData error', { ...error });
            });
    },

    resetStoreModuleData: ({ commit }) => {
        commit('resetStoreModuleData');
    }
};
